<app-menu-common url="hr"></app-menu-common>

@if (hrService.backendMissing()) {
	<div class="hr-backend-warn">Backend RH non déployé ou non à jour : données indisponibles (voir docs/backend-brief-hr2.md).</div>
}

<div class="flexrow hr-header">
	<h2>Effectifs minimum</h2>

	<mat-form-field class="pick">
		<mat-label>Établissement</mat-label>
		<mat-select [formControl]="storeCtrl">
			@for (s of stores; track s.id) {
				<mat-option [value]="s.id">{{ s.name }}</mat-option>
			}
		</mat-select>
	</mat-form-field>

	<mat-form-field class="pick">
		<mat-label>Service</mat-label>
		<mat-select [formControl]="activityCtrl">
			@for (a of storeActivities; track a.id) {
				<mat-option [value]="a.id">{{ a.name }}</mat-option>
			}
		</mat-select>
	</mat-form-field>

	@if (dirty) { <span class="dirty-chip">Modifications non enregistrées</span> }
	<span class="spacer"></span>
	@if (isAdmin) {
		<button mat-flat-button color="primary" (click)="onSave()" [disabled]="saving || !dirty" id="savecoveragebutton">
			{{ saving ? 'Enregistrement…' : 'Enregistrer' }}
		</button>
	}
</div>

<div class="pagecontent">
	<p class="hint">
		Regroupez les jours gérés pareil (« Lun–Ven », « Sam »…) puis dessinez l'effectif à la souris :
		glisser sur le vide = créer une tranche à la hauteur voulue, tirer le haut d'un bloc = changer le
		nombre de personnes, les bords = les heures. Hauteur et couleur suivent l'effectif exigé.
		{{ isAdmin ? '' : '(Édition réservée aux administrateurs.)' }}
	</p>

	@if (storeActivities.length === 0 && loaded) {
		<div class="hr-empty">
			Cet établissement n'a pas encore de service. <a routerLink="/hr/organization">Déclarer ses services</a>.
		</div>
	} @else {

		@for (group of groups; track $index) {
			<section class="group-card">
				<div class="flexrow group-head">
					<span class="group-title">{{ groupTitle(group) }}</span>
					<span class="day-chips">
						@for (d of weekdays; track d) {
							<button type="button" class="day-chip"
								[class.on]="group.days.includes(d)"
								[class.elsewhere]="inOtherGroup(group, d)"
								[disabled]="!isAdmin"
								[matTooltip]="dayLabels[d - 1]"
								(click)="onToggleDay(group, d)">{{ dayLetters[d - 1] }}</button>
						}
					</span>
					<span class="spacer"></span>
					@if (isAdmin) {
						<button mat-icon-button class="del-group" (click)="onRemoveGroup(group)" matTooltip="Supprimer cette gestion" aria-label="Supprimer cette gestion">
							<mat-icon>delete_outline</mat-icon>
						</button>
					}
				</div>

				@if (group.days.length === 0) {
					<div class="no-days">Choisissez ci-dessus les jours de cette gestion.</div>
				}

				<div class="chart">
					<div class="scale">
						@for (g of scaleGuides(); track g.label) {
							<span [style.bottom.%]="g.bottom">{{ g.label }}</span>
						}
					</div>
					<div class="lane" #lane [class.editable]="isAdmin" (pointerdown)="onLanePointerDown($event, group, lane)">
						@for (g of scaleGuides(); track g.label) {
							<div class="guide" [style.bottom.%]="g.bottom"></div>
						}
						@for (seg of groupTimeline(group); track $index) {
							@if (seg.cls === 'open') {
								<div class="seg open" [style.left.%]="seg.left" [style.width.%]="seg.width" [title]="seg.title"></div>
							} @else {
								<div class="seg need" [class.ink]="seg.ink"
									[style.left.%]="seg.left" [style.width.%]="seg.width" [style.height.%]="seg.height"
									[style.background]="seg.color" [title]="seg.title"
									(pointerdown)="onSegPointerDown($event, group, seg, lane, 'move')">
									<span class="handle top" (pointerdown)="onSegPointerDown($event, group, seg, lane, 'count')"></span>
									<span class="handle left" (pointerdown)="onSegPointerDown($event, group, seg, lane, 'start')"></span>
									@if (seg.width > 4) { <span class="count-label">{{ seg.label }}</span> }
									<span class="handle right" (pointerdown)="onSegPointerDown($event, group, seg, lane, 'end')"></span>
								</div>
							}
						}
					</div>
					<div class="ticks">
						@for (t of timelineTicks(); track t.left) {
							<span [style.left.%]="t.left">{{ t.label }}</span>
						}
					</div>
				</div>

				@for (row of group.rows; track $index; let i = $index) {
					<div class="flexrow slice-row">
						<input class="time" type="time" [(ngModel)]="row.start" (ngModelChange)="onEdited()" [disabled]="!isAdmin">
						<span class="sep">→</span>
						<input class="time" type="time" [(ngModel)]="row.end" (ngModelChange)="onEdited()" [disabled]="!isAdmin">
						<input class="count" type="number" min="0" [(ngModel)]="row.min" (ngModelChange)="onEdited()"
							[disabled]="!isAdmin" title="Effectif minimum sur cette tranche">
						<span class="unit">pers.</span>
						@if (isAdmin) {
							<button mat-icon-button class="del" (click)="onRemoveSlice(group, i)" matTooltip="Supprimer la tranche" aria-label="Supprimer la tranche">
								<mat-icon>close</mat-icon>
							</button>
						}
					</div>
				}
				@if (group.rows.length === 0 && group.days.length > 0) {
					<div class="no-slice">Pas de contrainte — dessinez une tranche sur la bande ci-dessus.</div>
				}
				@if (isAdmin) {
					<button mat-button class="add-slice" (click)="onAddSlice(group)">
						<mat-icon>add</mat-icon>&nbsp;Tranche
					</button>
				}
			</section>
		}

		<div class="flexrow groups-footer">
			@if (freeDaysLabel) {
				<span class="free-days">Jours sans contrainte : {{ freeDaysLabel }}</span>
			}
			<span class="spacer"></span>
			@if (isAdmin) {
				<button mat-stroked-button (click)="onAddGroup()">
					<mat-icon>add</mat-icon>&nbsp;Ajouter une gestion
				</button>
			}
		</div>
	}

	<section class="hr-block">
		<h3>Manques à venir <span class="horizon">{{ horizonLabel }}</span></h3>
		@if (shortfalls.length === 0) {
			<p class="hint">Aucun manque détecté sur la période : les plannings couvrent les effectifs minimum. 👍</p>
		} @else {
			<table class="shortfall-table">
				<thead>
					<tr><th>Semaine</th><th>Jour</th><th>Établissement</th><th>Service</th><th>Tranche</th><th>Présents / requis</th><th>Manque</th></tr>
				</thead>
				<tbody>
					@for (s of shortfalls; track $index) {
						<tr class="row" (click)="onOpenPlanning(s)" matTooltip="Ouvrir le planning de cette semaine">
							<td>S{{ s.week }}</td>
							<td>{{ s.dayLabel }}</td>
							<td>{{ s.storeName }}</td>
							<td>{{ s.activityName }}</td>
							<td>{{ s.hours }}</td>
							<td>{{ s.planned }} / {{ s.required }}</td>
							<td class="missing">−{{ s.missing }}</td>
						</tr>
					}
				</tbody>
			</table>
		}
	</section>

	<!-- Le miroir du manque. Un trou fait perdre du chiffre ; du monde payé à ne rien faire en
	     coûte tout autant. Le moteur savait le calculer depuis le début, l'écran ne le montrait pas. -->
	<section class="hr-block">
		<h3>Sureffectifs à venir <span class="horizon">{{ horizonLabel }}</span></h3>
		@if (surpluses.length === 0) {
			<p class="hint">Aucun sureffectif détecté sur la période : les plannings collent aux besoins.</p>
		} @else {
			<table class="shortfall-table">
				<thead>
					<tr><th>Semaine</th><th>Jour</th><th>Établissement</th><th>Service</th><th>Tranche</th><th>Présents / requis</th><th>En trop</th></tr>
				</thead>
				<tbody>
					@for (s of surpluses; track $index) {
						<tr class="row" (click)="onOpenPlanning(s)" matTooltip="Ouvrir le planning de cette semaine">
							<td>S{{ s.week }}</td>
							<td>{{ s.dayLabel }}</td>
							<td>{{ s.storeName }}</td>
							<td>{{ s.activityName }}</td>
							<td>{{ s.hours }}</td>
							<td>{{ s.planned }} / {{ s.required }}</td>
							<td class="surplus">+{{ s.surplus }}</td>
						</tr>
					}
				</tbody>
			</table>
		}
	</section>
</div>
